module.exports = __webpack_public_path__ + "media/images/common/kuchi_04-2943cc0e4fc2c4751b981ff1595c2d63.gif";